import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import EditAttachment from './../edit/EditAttachment';
import DialogBase from './DialogBase';
import { DialogContent, DialogTitle } from '@mui/material';

class DialogEditAttachment extends React.Component {

  render () {
    const { classes, open, onClose, attachment, ...others } = this.props;
    const scrollableTargetId = "dialog-edit-attachment";
    return (
      <DialogBase
        open={open}
        onClose={onClose}
      >
        <DialogTitle>{attachment?.ID ? "Modifier un média" : "Nouveau média"}</DialogTitle>
        <DialogContent classes={{root: classes.dialogContent}} id={scrollableTargetId}>
          <EditAttachment
            scrollableTarget={scrollableTargetId}
            attachment={attachment}
            {...others}
          />
        </DialogContent>
      </DialogBase>
    )
  }
}

const styles = theme => ({
  dialogContent: {
    padding: theme.spacing(0),
  },
});

DialogEditAttachment.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(DialogEditAttachment);
